import produce from "immer";
import {
  DISABLE_CALCUL_LOADER,
  DISABLE_DOWNLOAD_REPORTS_LOADER,
  DISABLE_REPORTS_LOADERS,
  ENABLE_CALCUL_LOADER,
  ENABLE_DOWNLOAD_REPORTS_LOADER,
  ENABLE_REPORTS_LOADERS,
  SAVE_FAMILY_PRODUCT_FDES,
  SAVE_FAMILY_PRODUCT_FDES_FAILED,
  SAVE_FAMILY_PRODUCT_FDES_SUCCESS,
  SAVE_FAMILY_PRODUCT_FORM,
  UPDATE_FAMILY_PRODUCT_FDES,
  UPDATE_FAMILY_PRODUCT_FDES_FAILED,
  UPDATE_FAMILY_PRODUCT_FDES_SUCCESS,
  UPDATE_FAMILY_PRODUCT_FORM,
} from "../../modules/family-product/constants";
import {
  SAVE_GROUP_FORM,
  UPDATE_GROUP_FORM,
} from "../../modules/manage-group/constants";
import {
  DISABLE_FAMILY_PRODUCT_FORM_LOADER,
  DISABLE_GROUP_FORM_LOADER,
  SEND_RECOVER_PASSWORD_FORM,
} from "../../modules/user/constants";
import { DISABLE_TABLE_SCROLL, ENABLE_TABLE_SCROLL } from "../constants/loader";

const initialState = {
  manageGroupFormIsLoading: false,
  familyProductFormIsLoading: false,
  modelFormIsLoading: false,
  calculIsLoading: false,
  isGeneratingReports: false,
  generatingReportsIds: [],
  sendRecoverPasswordFormIsLoading: false,
  tableScrollDisabled: false,
  isDownloadingReports: false,
};

const loaderReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case ENABLE_CALCUL_LOADER:
      draft.calculIsLoading = true;
      break;
    case DISABLE_CALCUL_LOADER:
      draft.calculIsLoading = false;
      break;
    case ENABLE_REPORTS_LOADERS:
      draft.isGeneratingReports = true;
      draft.generatingReportsIds = action.calculIds;
      break;
    case DISABLE_REPORTS_LOADERS:
      draft.isGeneratingReports = false;
      draft.generatingReportsIds = [];
      break;
    case UPDATE_FAMILY_PRODUCT_FORM:
    case SAVE_FAMILY_PRODUCT_FORM:
      draft.familyProductFormIsLoading = true;
      break;
    case DISABLE_FAMILY_PRODUCT_FORM_LOADER:
      draft.familyProductFormIsLoading = false;
      break;
    case SAVE_GROUP_FORM:
      draft.manageGroupFormIsLoading = true;
      break;
    case UPDATE_GROUP_FORM:
    case DISABLE_GROUP_FORM_LOADER:
      draft.manageGroupFormIsLoading = false;
      break;
    case UPDATE_FAMILY_PRODUCT_FDES:
    case SAVE_FAMILY_PRODUCT_FDES:
      draft.modelFormIsLoading = true;
      break;
    case SAVE_FAMILY_PRODUCT_FDES_FAILED:
    case SAVE_FAMILY_PRODUCT_FDES_SUCCESS:
    case UPDATE_FAMILY_PRODUCT_FDES_SUCCESS:
    case UPDATE_FAMILY_PRODUCT_FDES_FAILED:
      draft.modelFormIsLoading = false;
      break;
    case SEND_RECOVER_PASSWORD_FORM:
      draft.sendRecoverPasswordFormIsLoading = true;
      break;
    case "SEND_RECOVER_PASSWORD_SUCCESS":
    case "SEND_RECOVER_PASSWORD_FAILED":
      draft.sendRecoverPasswordFormIsLoading = false;
      break;
    case DISABLE_TABLE_SCROLL:
      draft.tableScrollDisabled = true;
      break;
    case ENABLE_TABLE_SCROLL:
      draft.tableScrollDisabled = false;
      break;
    case ENABLE_DOWNLOAD_REPORTS_LOADER:
      draft.isDownloadingReports = true;
      break;
    case DISABLE_DOWNLOAD_REPORTS_LOADER:
      draft.isDownloadingReports = false;
      break;
    default:
      return draft;
  }
});

export default loaderReducer;
